import { Component, OnDestroy, OnInit } from "@angular/core";
import {
	UntypedFormGroup,
	UntypedFormControl,
	Validators
} from "@angular/forms";
import { Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";
import { GlobalService } from "@ds-shared/common-services/http-services/global.service";
import { CommonFunctionsService } from "@ds-shared/common-services/utility-services/common-functions.service";
import { NotificationService } from "@ds-shared/common-services/utility-services/notification.service";
import { CommonModel } from "@ds-shared/models/common.model";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
	selector: "app-forgot-password",
	templateUrl: "./forgot-password.component.html",
	styleUrls: ["./forgot-password.component.scss"]
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
	public forgotPasswordForm: UntypedFormGroup;
	constructor(
		private globalService: GlobalService,
		public commonFunctions: CommonFunctionsService,
		private notificationService: NotificationService,
		public router: Router
	) {}
	private destroy$: Subject<boolean> = new Subject();
	ngOnInit(): void {
		this.forgotPasswordForm = new UntypedFormGroup({
			email_id: new UntypedFormControl(
				null,
				// eslint-disable-next-line @typescript-eslint/unbound-method
				[Validators.required, Validators.pattern(/^[\w.-]+@[\w.-]+\.\w+$/)]
			)
		});
	}

	onSubmit() {
		if (!this.forgotPasswordForm.controls["email_id"].value) {
			this.forgotPasswordForm.controls["email_id"].markAsTouched();
			this.forgotPasswordForm.controls["email_id"].setErrors({
				emailError: this.commonFunctions.getSpecificTranslation(
					"Please enter email Id."
				)
			});
		} else {
			if (this.forgotPasswordForm.controls["email_id"].status !== "INVALID") {
				this.globalService
					.sendResetPasswordLink({
						email: this.forgotPasswordForm.get("email_id").value as string
					})
					.pipe(takeUntil(this.destroy$))
					.subscribe(
						(res: CommonModel) => {
							this.notificationService.setMessage(
								res.context_code,
								res.summary
									? res.summary
									: this.commonFunctions.getSpecificTranslation(
											"Something went wrong, please try again."
									  )
							);
						},
						(err: HttpErrorResponse) => {
							const { summary } = err.error as CommonModel;
							this.notificationService.setMessage(
								1100,
								summary
									? summary
									: this.commonFunctions.getSpecificTranslation(
											"Something went wrong, please try again."
									  )
							);
						}
					);
			} else {
				const inputElement = document.getElementById("emailID");
				inputElement.focus();
			}
		}
	}

	public ngOnDestroy(): void {
		this.destroy$.next(true);
		this.destroy$.unsubscribe();
	}
}
